// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__GUgPA","description":"MealItem_description__AmaSV","price":"MealItem_price__qfh14"};